const Component = () => import('./Home');

export { Component };
